import { render } from "./DetailsCommande.vue?vue&type=template&id=15412454"
import script from "./DetailsCommande.vue?vue&type=script&lang=js"
export * from "./DetailsCommande.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jonathanthomas/Documents/Sites/vuejs/gr2022-phase-fin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__